export {};
//# sourceMappingURL=iEffectFallbacks.js.map